import styled from 'styled-components';
import { Button } from 'components';
import { MASKED_TEXT_CLASS } from 'analytics/constants';
import { LevelMeter } from './LevelMeter';
import { TestToneButton } from './TestToneButton';
import { TONE_SURFACES } from './toneSurfaces';

export type IconTone = 'connected' | 'available' | 'warning' | 'error';

const ICON_TONE_CLASSES: Record<IconTone, string> = {
  connected: TONE_SURFACES.accent,
  available: 'bg-vantis-violet/30 text-white',
  warning: TONE_SURFACES.warning,
  error: TONE_SURFACES.error,
};

export const DeviceCard = styled.section.attrs({
  className:
    'space-y-4 rounded-md border border-border p-3 shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
})``;

export const DeviceCardSearching = styled.div.attrs({
  className: 'flex items-center gap-2 text-sm text-muted-foreground',
})``;

export const DeviceCardDivider = styled.hr.attrs({
  className: 'border-border',
})``;

export const DeviceCardTitle = styled.h3.attrs({
  className: 'text-sm font-medium',
})``;

export const DeviceCardHeader = styled.div.attrs({
  className: 'flex items-start gap-3',
})``;

export const DeviceCardIcon = styled.span.attrs<{ $tone: IconTone }>(({ $tone }) => ({
  className: `flex size-8 shrink-0 items-center justify-center rounded-full ${ICON_TONE_CLASSES[$tone]}`,
}))<{ $tone: IconTone }>``;

export const DeviceCardSummary = styled.div.attrs({
  className: 'min-w-0 space-y-1',
})``;

export const DeviceCardHeading = styled.p.attrs({
  className: `text-sm font-semibold ${MASKED_TEXT_CLASS}`,
})``;

export const DeviceCardBadges = styled.div.attrs({
  className: 'flex flex-wrap gap-2',
})``;

export const DeviceCardDescription = styled.p.attrs({
  className: 'text-xs text-muted-foreground',
})``;

export const DeviceCardMaskedDescription = styled.p.attrs({
  className: `text-xs text-muted-foreground ${MASKED_TEXT_CLASS}`,
})``;

export const UseDeviceButton = styled(Button).attrs({
  className: 'ml-auto h-7 shrink-0 rounded-lg px-2.5 text-sm font-semibold',
})``;

export const DeviceCardActions = styled.div.attrs({
  className: 'flex flex-wrap gap-2',
})``;

export const RetestButton = styled(Button).attrs({
  variant: 'outline',
  className:
    'h-8 rounded-lg border-primary bg-white px-2.5 text-xs font-medium text-primary hover:bg-vantis-silver hover:text-primary',
})``;

export const OpenSettingsButton = styled(Button).attrs({
  className: 'h-8 rounded-lg px-2.5 text-xs font-medium',
})``;

export const PreviewBox = styled.div.attrs({
  className: 'space-y-3 rounded-md bg-vantis-silver px-3 py-2',
})``;

export const PreviewRow = styled.div.attrs({
  className: 'flex items-center gap-6',
})``;

export const PreviewLabel = styled.span.attrs({
  className: 'flex-1 text-xs font-semibold',
})``;

export const PreviewLevelMeter = styled(LevelMeter).attrs({
  className: 'flex-1',
})``;

export const PreviewSpeaker = styled.div.attrs({
  className: 'min-w-0 flex-1',
})``;

export const PreviewSpeakerLabel = styled.p.attrs({
  className: 'text-xs font-semibold',
})``;

export const PreviewSpeakerName = styled.p.attrs({
  className: `truncate text-xs text-muted-foreground ${MASKED_TEXT_CLASS}`,
})``;

export const PreviewTestTone = styled.div.attrs({
  className: 'flex-1',
})``;

export const PreviewTestToneButton = styled(TestToneButton).attrs({
  className: 'h-7 px-2.5 text-xs',
})``;
